// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3x3UA","approved":"Status_approved__3Kf5F","rejected":"Status_rejected__3k27S","expired":"Status_expired__2kslD","label":"Status_label__oeV1q"};